export default __webpack_public_path__ + "static/media/sgenaralicon.0bac2ff7.svg";